import { render, staticRenderFns } from "./AddProjectType.vue?vue&type=template&id=344d88d3&"
import script from "./AddProjectType.vue?vue&type=script&lang=js&"
export * from "./AddProjectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports